<template>
        <div class="templete">
            <div class="search_box clearfix StockSearch">
                <el-input class="search_input search_inputBox" v-model="params.name" placeholder="客户名称"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.linkman" placeholder="联系人"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.phone" placeholder="联系电话"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.main_business" placeholder="主营业务"></el-input>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                <el-button  class="publicBtn" v-if="module.indexOf(',customer-add,')!=-1" @click="openAddCustmoer()" style="margin-left: 14px;background-color: #fff;color:#000;">新增</el-button>
            </div>
            <div class="tableBox selectStockTable">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" :selecttype="1" @rowClick="rowClick"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <div class="btnList clearfix">
                <div class="btnBox">
                    <el-button  class="funcPublicBtn" @click="cancel">取消</el-button>
                    <!-- <el-button  class="funcPublicBtn" @click="selectData">选中</el-button> -->
                    <el-button  class="funcPublicBtn funcPublicBtnChecked" @click="selectAndOut">选中并退出</el-button>
                </div>
            </div>
            <el-dialog v-dialog-drag :title="updataType==2?'新增客户':'修改客户'" class="eldialog eldialogA" :visible.sync="dialogVisible" :model="false" custom-class="full_dialog">
                <div class="">
                    <el-form :model="form_params" :rules="rules" ref="edit_form" style="overflow-y: auto;max-height: 600px;">
                        <div class="dialog_path_title eldialogFormTag">基本信息</div>
                        <div class="eldialogFormBox clearfix">
                            <el-form-item label="公司名称：" prop="name">
                                <el-input class="edit_input" v-model="form_params.name" placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item label="公司地址：" prop="address">
                                <el-input class="edit_input" v-model="form_params.address" placeholder=""></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="联系人：" prop="linkman">
                                <el-input class="edit_input" v-model="form_params.linkman" placeholder=""></el-input>
                            </el-form-item> -->
                            <el-form-item label="所属人：" prop="salesman_id">
                                <el-select class="edit_input" v-model="form_params.salesman_id" @visible-change="getSelectList('user')">
                                    <el-option v-for="sale in selectMap.user" :key="sale.id" :value="sale.id" :label="sale.name"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="电话/传真：" prop="fax">
                                <el-input class="edit_input" v-model="form_params.fax" placeholder=""></el-input>
                            </el-form-item>
                            <!-- <el-form-item label="联系电话：" prop="phone">
                                <el-input class="edit_input" v-model="form_params.phone" placeholder=""></el-input>
                            </el-form-item> -->
                            <!-- <el-form-item label="微信：" prop="wechat">
                                <el-input class="edit_input" v-model="form_params.wechat" placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item label="电子邮箱：" prop="email">
                                <el-input class="edit_input" v-model="form_params.email" placeholder=""></el-input>
                            </el-form-item> -->
                            <el-form-item label="工厂规模：" prop="factory_size">
                                <el-input class="edit_input" v-model="form_params.factory_size" placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item label="厂房信息：" prop="factory_size">
                                <el-input class="edit_input" v-model="form_params.factory_info" placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item label="采购木种：" prop="wood_category">
                                <el-input class="edit_input" v-model="form_params.wood_category" placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item label="其他信息：" prop="other_info">
                                <el-input class="edit_input" v-model="form_params.other_info" placeholder=""></el-input>
                            </el-form-item>
                        </div>
                        <div class="eldialogFormBox clearfix">
                            <el-form-item label="所在省份：" prop="province_id">
                                <el-select class="edit_input" v-model="form_params.province_id" @change="changePro($event,2)">
                                    <el-option v-for="pro in proList" :key="pro.id" :value="pro.id" :label="pro.name"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="所在城市：" prop="city_id">
                                <el-select class="edit_input" v-model="form_params.city_id">
                                    <el-option v-for="city in cityList" :key="city.id" :value="city.id" :label="city.name"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="客户属性：" prop="customer_attribute_id">
                                <el-select class="edit_input" v-model="form_params.customer_attribute_id" @visible-change="getSelectList('customerAttribute')">
                                    <el-option v-for="attribute in selectMap.customerAttribute" :key="attribute.id" :value="attribute.id" :label="attribute.name"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="客户来源：" prop="customer_source_id">
                                <el-select class="edit_input" v-model="form_params.customer_source_id" @visible-change="getSelectList('customerSource')">
                                    <el-option v-for="source in selectMap.customerSource" :key="source.id" :value="source.id" :label="source.name"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="主营项目：" prop="main_business">
                                <el-input class="edit_input" v-model="form_params.main_business" placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item label="信用指数：" prop="star">
                                <el-select class="edit_input" v-model="form_params.star">
                                    <el-option :value="1" :label="'一星'"></el-option>
                                    <el-option :value="2" :label="'二星'"></el-option>
                                    <el-option :value="3" :label="'三星'"></el-option>
                                    <el-option :value="4" :label="'四星'"></el-option>
                                    <el-option :value="5" :label="'五星'"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="客户文件：" v-if="form_params.files">
                                <span style="float: left;font-size: 12px;color: #b21111;" @click="openFile">资料查看</span><img  @click="openFile" class="file" src="/icon/file.png">
                            </el-form-item>
                            <el-form-item v-else>
                            </el-form-item>
                            <div class="mark">
                                <el-form-item label="备注：" prop="remark">
                                    <!-- <el-input class="edit_input" v-model="form_params.remark" placeholder=""></el-input> -->
                                    <div class="content_box">
                                        <span class="content">{{form_params.remark}}</span>
                                        <span class="edit cursorPointer"  @click="markEdit"></span>
                                    </div>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="dialog_path_title eldialogFormTag">联系方式</div>
                        <template v-for="(item,index) in form_params.contacts">                
                            <div :class="['link_item', index == 0 ? '':'add_item']" :key="index">
                                <div class="eldialogFormBox clearfix">
                                    <el-form-item label="联系人：" :prop="`contacts[${index}].contact`" :rules="{ required: true, message: '必填项', trigger: 'change' }">
                                        <el-input v-model="item.contact" class="edit_input" ></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系电话：" :prop="`contacts[${index}].phone`" :rules="{ required: true, message: '必填项', trigger: 'change' }">
                                        <el-input v-model="item.phone" class="edit_input" ></el-input>
                                    </el-form-item>            
                                </div>
                                <div class="eldialogFormBox clearfix">
                                    <el-form-item label="微信：">
                                        <el-input v-model="item.wechat" class="edit_input" ></el-input>
                                    </el-form-item>
                                    <el-form-item label="电子邮箱：">
                                        <el-input v-model="item.email" class="edit_input" ></el-input>
                                    </el-form-item>
                                </div>
                                <div :class="['item_icon','cursorPointer',index == 0 ? 'add_icon':'del_icon']"  @click="addOrDelete(index)"></div>
                            </div>
                        </template>    
                        <div class="dialog_path_title eldialogFormTag">开票资料</div>
                        <div class="eldialogFormBox eldialogFormTag clearfix">
                            <el-form-item label="名称：" prop="invoice_name" style="margin-top: 21px;">
                                <el-input class="edit_input" v-model="form_params.invoice_name" placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item label="开户行：" prop="invoice_bank_name" style="margin-top: 21px;">
                                <el-input class="edit_input" v-model="form_params.invoice_bank_name" placeholder=""></el-input>
                            </el-form-item>
                        </div>
                        <div class="eldialogFormBox eldialogFormTag clearfix">
                            <el-form-item label="税号：" prop="invoice_no">
                                <el-input class="edit_input" v-model="form_params.invoice_no" placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item label="账号：" prop="invoice_bank_no">
                                <el-input class="edit_input" v-model="form_params.invoice_bank_no" placeholder=""></el-input>
                            </el-form-item>
                        </div>
                        <div class="eldialogFormBox eldialogFormTag clearfix">
                            <el-form-item label="地址：" prop="invoice_addr">
                                <el-input class="edit_input" v-model="form_params.invoice_addr" placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item label="电话：" prop="invoice_phone">
                                <el-input class="edit_input" v-model="form_params.invoice_phone" placeholder=""></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="dialogBtnList clearfix">
                    <el-button  class="publicBtn dialogBtn" @click="addCustomer">确定</el-button>
                    <el-button class="dialogBtn funcPublicBtn" @click="dialogVisible=!dialogVisible">关闭</el-button>
                </div>
            </el-dialog>
            <!-- 备注 -->
            <el-dialog title="备注" :visible.sync="markDialogVisible" class="eldialog mark_dialog" width="350px" :modal="false" :before-close="markhandleClose" v-dialogDrag>
                <div>
                    <el-input type="textarea" :rows="5" placeholder="请输入内容" maxlength=100 v-model="form_params.remark"></el-input>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button class="sm_confirm_btn" type="primary" size="small" @click="markDialogVisible=false">确认</el-button>
                </span>
            </el-dialog>
            <!-- 备注 -->
        </div>
</template>
<script>
    import tabletem from './table.vue'
    import pagination from './pagination.vue'
    export default {
        props:['saleman'],
        data(){
            return{
                module:localStorage.dw_erp_power_code,
                tableLoading:false,
                params:{
                    name:"",
                    linkman:"",
                    phone:"",
                    main_business:"",
                    salesman_id:this.saleman?[this.saleman]:[],
                    per_page:50,
                    page:1
                },
                last_page:1,
                total:0,
                selectRow:[],
                list:[],
                tableCol:[	
                    {colName:"客户名称",colKey:"name",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"联系人",colKey:"linkman",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"联系电话",colKey:"phone",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"主营业务",colKey:"main_business",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"客户属性",colKey:"customer_attribute_name",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                dialogVisible : false,
                updataType:2,
                form_params : {
                    id:"",
                    name : "",
                    salesman_id: localStorage.dw_erp_user_id ? parseInt(localStorage.dw_erp_user_id) : "",
                    // linkman : "",
                    // phone : "",
                    address : "",
                    province_id : "",
                    city_id : "",
                    // email : "",
                    main_business : "",
                    remark : "",
                    // wechat: "",
                    fax: "",
                    customer_attribute_id: "",
                    customer_source_id: "",
                    star:"",
                    invoice_name:"",
                    invoice_no:"",
                    invoice_bank_name:"",
                    invoice_bank_no:"",
                    invoice_addr:"",
                    invoice_phone:"",
                    factory_size:"",
                    factory_info:"",
                    wood_category:"",
                    other_info:"",
                    contacts:[
                         {contact: '', phone:'', wechat: '', email: ''}
                    ],
                },
                rules: {
                    name : [ { required: true, message: '请输入公司名称', trigger: 'blur' } ],
                    salesman_id : [ { required: true, message: '请选择归属人', trigger: 'blur' } ],
                    // linkman : [ { required: true, message: '请输入联系人', trigger: 'blur' } ],
                    // phone : [ {required: true,  message: '请输入联系电话', trigger: 'blur' } ]
                },
                proList:[],
                cityList:[],
                cityListS:[],
                selectMap:{
                    user:[],
                    customerSource:[],
                    customerAttribute:[]
                },
                markDialogVisible:false,
            }
        },
        created(){
            this.getSelectList("user")
            this.getSelectList("customerSource")
            this.getSelectList("customerAttribute")
            this.getArea().then(resolve=>{
                this.proList=resolve.data.data;
            })
            this.getList()
        },
        methods:{
            cancel(){
                this.$emit("cancel")
            },
            // selectData(){
            //     this.$emit("selectData",this.selectRow)
            // },
            selectAndOut(){
                this.$emit("selectAndOut",this.selectRow)
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.params.salesman_id=this.saleman?[this.saleman]:[];
                this.getList();
            },
            //新增表单 多个联系人删除修改
            addOrDelete(index){
                let newForm = JSON.parse(JSON.stringify(this.form_params))
                if(index == 0){
                    newForm.contacts.push( {contact: '',phone:'',wechat: '',email: ''})
                }else{
                    newForm.contacts.splice(index, 1)
                }
                this.form_params = newForm
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.postFunc("erp/customer.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.data;
                    this.list.forEach((item,ind)=>{
                        if(item.status==1){
                            item.isCanSelection=false;
                        }else{
                            item.isCanSelection=true;
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(){},
            getRow(row){
                this.selectRow=row;   
            },
            openAddCustmoer(){
                // this.updataType=2
                this.form_params.contacts = [{contact: '',phone:'',wechat: '',email: ''}]
                this.dialogVisible = true;
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            //备注编辑
            markEdit(){
                this.markDialogVisible = true
                this.markCopy = this.form_params.remark
            },
            //弹窗关闭回调
            markhandleClose(){
                this.markDialogVisible  =false 
                this.form_params.remark = this.markCopy
            },
            addCustomer(){
                this.$refs["edit_form"].validate((valid) => {
					if (valid) {
                        if(this.updataType==2){
                            this.postFuncLoading("/erp/customer.create",this.form_params,()=>{
                                this.tip("添加成功","success")
                                this.getList();
                                this.form_params = this.resetJson(this.form_params)
                                this.dialogVisible=false;
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }
					} else {
						return false;
					}
				});
            },
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "saleman":function(val){
                this.params.salesman_id = [val];
                this.getList();
            }
        }
    }
</script>
<style scoped lang="scss">
    .pageAssembly .pageSize{margin-top:3px;}
    .totalBox{float: left;}
    .totalBox .total{float: left;font-size: 12px;line-height: 33px;margin-right:15px;}
    .btnBox{float: right;}
    .dialog_path_title{text-align: center;font-size:14px; font-weight:bold; line-height:25px; color: #606266;padding-bottom:20px;background-color: #fff;}
    .link_item{
            // padding-right: 50px;
            // margin:0 37px;      
            // margin-top:20px;
            position:relative;
        .item_icon{      
            position:absolute;
            right: 0px;
            top:26px;
            display: block;
            width: 25px;
            height: 25px;
        }
        .add_icon{           
            background: url(/icon/frame_plus.png) center center no-repeat;
            background-size: 16px 16px;
        }
        .del_icon{
            background: url(/icon/frame_minus.png) center center no-repeat;
            background-size: 16px 16px;
        }
    }  
    .add_item{
        border-top: 1px dashed #aaa;
        margin-top: 0px;
        padding-top: 10px;
    }
    .mark{
        .content_box{
            width: 140px; 
            border-bottom: 1px solid #DCDFE6;
            display:flex;
            padding-left: 10px;
            .content{
                flex: 1;
                display: inline-block;
                width: 120px;
                height: 24px;
                text-align:left;
                overflow:hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 12px;
            }
            .edit{
                display:inline-block;
                width:20px;
                background: url(/icon/operation_edit.png) 100% 65% no-repeat;
                background-size: 16px 16px;
            }         
        }
    }
</style>